import React, { useEffect, useState } from 'react';

import TreeSearchDropdown from '../../../components/TreeSearchDropdown';
import { getUITA } from '../../../utils/commonUtils';

const ColumnCell = ({ row, column: { accessor: key } }) => {
  const [value, setValue] = useState(row[key]);
  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);

  useEffect(() => {
    setValue(row[key]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[key]]);

  const handleColumnChange = (value) => {
    row.editRow({ rowId: row.rowId, key, value, error });
  };

  return (
    <TreeSearchDropdown
      row={row}
      columns={row.entityColumns}
      value={value}
      onChange={handleColumnChange}
      disabled={false}
      ui-ta={getUITA('FormCtrl SSDropDown ColumnSelect')}
      showLabel={false}
      required
      asteriskPosition="before"
      error={!!error}
    />
  );
};

export default ColumnCell;
